// ── 흐름 대시보드 데이터 페치 훅 ──────────────────────────────────────────────
// /api/admin/cashflow/summary + /api/admin/cashflow/manual-entries

import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';

export function useCashflowData({ year, month, showToast }) {
  const [summary, setSummary] = useState(null);
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reloadTick, setReloadTick] = useState(0);

  const reload = useCallback(() => setReloadTick((t) => t + 1), []);

  useEffect(() => {
    let active = true;
    setLoading(true);
    (async () => {
      const [sumRes, entRes] = await Promise.all([
        apiClient.get(`/api/admin/cashflow/summary?year=${year}&month=${month}`),
        apiClient.get(`/api/admin/cashflow/manual-entries?year=${year}&month=${month}`),
      ]);
      if (!active) return;
      if (sumRes.ok && sumRes.data?.success) {
        setSummary(sumRes.data.data);
      } else {
        showToast?.(sumRes.data?.message || '흐름 데이터를 불러오지 못했습니다.', 'error');
        setSummary(null);
      }
      if (entRes.ok && entRes.data?.success) {
        setEntries(entRes.data.data || []);
      } else {
        setEntries([]);
      }
      setLoading(false);
    })();
    return () => { active = false; };
  }, [year, month, reloadTick, showToast]);

  const inflowEntries = entries.filter((e) => e.direction === 'inflow');
  const outflowEntries = entries.filter((e) => e.direction === 'outflow');
  return { summary, inflowEntries, outflowEntries, loading, reload };
}
